import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-24">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.04)] p-12" data-testid="payment-cancel-message">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-red-600" />
          </div>
          <h1 className="text-3xl font-light text-[#374963] mb-4">Pago Cancelado</h1>
          <p className="text-[#73706e] mb-8 leading-relaxed">
            Tu pago ha sido cancelado. No se ha realizado ningún cargo a tu cuenta.
          </p>
          <div className="space-y-3">
            <button
              onClick={() => navigate('/carrito')}
              className="w-full px-6 py-3 bg-[#374963] text-white rounded-lg hover:bg-[#4A5F7D] transition-colors"
              data-testid="go-to-cart-button"
            >
              Volver al Carrito
            </button>
            <button
              onClick={() => navigate('/')}
              className="w-full px-6 py-3 bg-white border border-[rgba(55,73,99,0.2)] text-[#374963] rounded-lg hover:bg-[#FAFAFA] transition-colors"
              data-testid="go-to-home-from-cancel-button"
            >
              Volver al Inicio
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;